export default "__VITE_ASSET__CCv8sqgs__"